// TODO AVWebStorefront-1171 This shouldn't be done with such a naive regex and
// should instead be handled with a special control sequence passed by WPS
const DEFAULT_WPS_SIZE_REGEX = /UX667_UY375_/
const EXTENSION_REGEX = /\.[a-zA-Z]+$/
// Match any sequence of alphanumeric , or _ characters, enclosed in ._ _.
const STYLE_TAG_REGEX = /\.(_[a-zA-Z0-9,_]+)$/
const DUPLICATE_UNDERSCORE_REGEX = /__+/g

export function scaleImageUrl(url: string, width: number, format: string) {
  const extension = (url.match(EXTENSION_REGEX) && url.match(EXTENSION_REGEX)[0]) || ''
  const extensionlessUrl = url.replace(EXTENSION_REGEX, '')

  // Extract the original style tags, strip the specified sizing tags
  const originalStyleTags = (extensionlessUrl.match(STYLE_TAG_REGEX) &&
  extensionlessUrl.match(STYLE_TAG_REGEX)[1] || '')
    .replace(DEFAULT_WPS_SIZE_REGEX, '')
  const bareUnsizedUrl = extensionlessUrl.replace(STYLE_TAG_REGEX, '')

  // Construct new style tags and normalise duplicate underscores
  const newStyleTags = `${originalStyleTags}_SX${width}`
    .replace(DUPLICATE_UNDERSCORE_REGEX, '_')

  // Construct new URL
  const newStyledUrl = `${bareUnsizedUrl}.${newStyleTags}`

  return `${newStyledUrl}_FM${format}_${extension}`
}
